import { observable, computed, action } from 'mobx';

import therapiesFixtures from './fixtures/therapies';


export class TherapiesStore {
  _therapies$ = observable.array(null);

  @computed
  get therapies$() {
    if (!this._therapies) {
      this.loadTherapies();
    }

    return this._therapies$;
  };

  @action
  loadTherapies() {
    this._therapies$ = therapiesFixtures;
  }
}




// WEBPACK FOOTER //
// ./src/modules/therapies/therapies.store.js